import React, { useContext, useEffect, useState } from 'react';
import moment from "moment"
import Select from 'react-select';

import { changeBooking } from "../../../api/apiRequests";
import { UsersContext } from "../../../hooks/wrappers/UsersWrapper";
import useErrors from "../../../hooks/useErrors";

import FormPickUp from "./modify/FormPickUp";
import FormLeaveIt from "./modify/FormLeaveIt";
import Loading from "../../shared/wait/Loading";
import PieceOfInfo from "../../shared/PieceOfInfo";
import MySubmit from "../../shared/form/MySubmit";
import useFormHandlers from "../../../hooks/useFormHandlers";

const ModalBooking = ({ booking, afterUpdate, changeModal }) => {
  const { users } = useContext(UsersContext)
  const { errors, captureErrors } = useErrors()
  const [data, setData] = useState({
    pickUp: booking ? { ...booking.pickUp } : {
      date: moment().toDate(),
      delivery: false,
      adress: "",
      location: "",
      cp: "",
      phone: "",
      comments: ""
    },
    leaveIt: booking ? { ...booking.leaveIt } : {
      date: moment().add(1, "d").toDate(),
      delivery: false,
      samePlace: false,
      adress: "",
      location: "",
      cp: "",
      phone: "",
      comments: ""
    },
    selectedUser: null
  })
  const { pickUp, leaveIt, selectedUser } = data;
  const { handleInputChange } = useFormHandlers(setData)

  const [selectionUsers, setSelectionUsers] = useState(null)
  useEffect(() => {
    const selectionUsers = [];
    let userDefault = null;
    users.forEach(user => {
      if (user.active) {
        const option = {
          value: user._id,
          label: (user.name + " " + user.surname + " - " + user.passport + " - " + user.email)
        };
        selectionUsers.push(option);
        if (booking) {
          if (user._id === booking.user._id) {
            userDefault = option;
          }
        }
      }
    });
    setSelectionUsers(selectionUsers)
    handleInputChange('selectedUser', userDefault)
    // eslint-disable-next-line
  }, [])


  useEffect(() => {
    checkSamePlace(data.leaveIt)
    // eslint-disable-next-line
  }, [leaveIt.samePlace])

  useEffect(() => {
    checkDeliveries(data)
    // eslint-disable-next-line
  }, [leaveIt.delivery])

  useEffect(() => {
    checkDeliveries(data)
    // eslint-disable-next-line
  }, [pickUp.delivery])

  const checkDeliveries = ({ pickUp, leaveIt }) => {
    !pickUp.delivery && setData(data => ({
      ...data,
      pickUp: {
        ...pickUp,
        adress: "",
        location: "",
        cp: "",
        phone: ""
      },
      leaveIt: {
        ...leaveIt,
        samePlace: false
      }
    }));

    !leaveIt.delivery && cleanSomeData("leaveIt", { ...leaveIt, samePlace: false });
  };

  const checkSamePlace = leaveIt =>
    leaveIt.samePlace && cleanSomeData("leaveIt", leaveIt);

  const cleanSomeData = (key, object) =>
    setData(data => ({
      ...data,
      [key]: {
        ...object,
        adress: "",
        location: "",
        cp: "",
        phone: ""
      }
    }))

  const setHourMinute = (instanceOfTime, hourAndMinute) => {
    const time = (Array.isArray(hourAndMinute) ? hourAndMinute : hourAndMinute.split(":", 2));
    return moment(instanceOfTime).hour(time[0]).minute(time[1]).toDate();
  };

  const changeInitDate = (initDate) => {
    if (initDate !== null) {
      const currInitDate = moment(pickUp.date);
      const newInitDate = setHourMinute(initDate, [currInitDate.hour(), currInitDate.minute()]);
      handleInputChange("pickUp.date", Date.parse(newInitDate));
    }
  };
  const changeEndDate = (endDate) => {
    if (endDate !== null) {
      const currEndDate = moment(leaveIt.date);
      const newEndDate = setHourMinute(endDate, [currEndDate.hour(), currEndDate.minute()]);
      handleInputChange("leaveIt.date", Date.parse(newEndDate));
    }
  };
  const changeInitHour = (initHourAndMinute) => {
    if (initHourAndMinute !== null) {
      const currInitDate = pickUp.date;
      const newInitDate = setHourMinute(currInitDate, initHourAndMinute);
      handleInputChange("pickUp.date", Date.parse(newInitDate));
    }
  };
  const changeEndHour = (endHourAndMinute) => {
    if (endHourAndMinute !== null) {
      const currEndDate = leaveIt.date;
      const newEndDate = setHourMinute(currEndDate, endHourAndMinute);
      handleInputChange("leaveIt.date", Date.parse(newEndDate));
    }
  };

  const submit = (event) => {
    event.preventDefault();
    if (errors.length < 1) update()
    else alert("Todos los campos son obligatorios")
  }

  const update = () => {
    const days = Math.ceil(moment(leaveIt.date).diff(moment(pickUp.date), "days", true));
    changeBooking(booking._id, pickUp, leaveIt, selectedUser.value, days)
      .then(() => {
        afterUpdate();
        changeModal(null);
        alert("Se ha actualizado la reserva")
      })
      .catch(() => {
        alert("No se ha podido actualizar la reserva")
      })
  };

  return (
    <div className="bg-white p-5"
         style={{ minWidth: "300px", width: "90vw", maxWidth: "1500px", minHeight: "200px" }}>
      <form onSubmit={submit} className="row">
        <div className="col-12">
          <PieceOfInfo title="CLIENTE"/>
          <div className="row">
            {selectionUsers ? <Select
              name="userSelect"
              value={selectedUser}
              onChange={user => handleInputChange('selectedUser', user)}
              options={selectionUsers}
              className="rounded-0 w-100"
            /> : <Loading text="Cargando usuarios..." height="auto"/>}
          </div>
        </div>
        <div className="col-12 mt-5">
          <FormPickUp
            changeDate={changeInitDate}
            changeHour={changeInitHour}
            info={pickUp}
            change={e => handleInputChange("pickUp."+e.target.name, e.target.value)}
            captureErrors={captureErrors}
          />
        </div>
        <div className="col-12 mt-5">
          <FormLeaveIt
            info={leaveIt}
            infoPickUp={pickUp}
            changeDate={changeEndDate}
            changeHour={changeEndHour}
            change={e => handleInputChange("leaveIt."+e.target.name, e.target.value)}
            captureErrors={captureErrors}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-3 offset-lg-8 offset-md-6">
          <div className="row">
            <MySubmit className="col bg-primary" text={booking ? "ACTUALIZAR" : "CREAR"}/>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ModalBooking
